import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import CustomerGroup3ManagementColumnModel from './customer-group3-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const CustomerGroup3ManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Customer Group 3 Management";
  //   },[]);  
    useDocumentTitle();
  return (
    <CommonTablePage
      urlInfoKey={urlKey.CustomerGroup3}
      title="Customer Group 3 Management"
      column={CustomerGroup3ManagementColumnModel.CustomerGroup3ManagementColumn}
    />
  )
}

export default CustomerGroup3ManagementPage
